export const fileCopy = {
  _title: 'Copies de fichiers',
  subtitle: 'Transferts de fichiers depuis un Drive partagé vers un bucket de stockage',
  operationsTab: 'Historique des copies',
  createTab: 'Nouvelle copie',
  fileCopyOperationsList: 'Liste des opérations de copies',
  create: {
    title: 'Nouvelle copie',
    source: 'Source — Drive',
    back: '← Retour',
    destination: 'Destination — Bucket',
    bucket: 'Bucket',
    fixedBucketDestination: 'Destination bucket fixe. Non modifiable',
    prefix: 'Sous-dossier (préfixe)',
    prefixPlaceholder: '/livraisons/2026/',
    keepTree: "Conserver l'arborescence des dossiers Drive",
    overwrite: 'Écraser les fichiers déjà présents à destination',
    recap: 'Récapitulatif',
    recapSource: 'Source',
    recapSelection: 'Sélection',
    recapDestination: 'Destination',
    recapTree: 'Arborescence',
    recapTreeKept: 'Conservée',
    recapTreeNotKept: 'Non conservée',
    recapExisting: 'Fichiers existants',
    recapOverwriteYes: 'Écrasés',
    recapOverwriteNo: 'Conservés',
    readyToCopy: 'Prêt à copier ≈ %{files} fichiers',
    selectionSummary: '%{folders} dossier(s) et %{files} fichier(s)',
    unselect: 'Retirer %{name} de la sélection',
    clearSelection: 'Tout désélectionner',
    estimatedTotal: '≈ %{files} fichiers · %{size}',
    unsupportedIgnored: '%{count} fichiers non supportés seront ignorés',
    dryRun: 'Simuler (dry run)',
    launch: 'Lancer la copie',
    dryRunResult: 'Résultat de la simulation',
    dryRunSummary: '%{files} fichiers · %{size}',
    existingAtDestination: ' · %{count} existent déjà à destination',
    error: 'Erreur',
  },
  list: {
    headers: {
      operation: 'Opération',
      status: 'Statut',
      selectionAndDestination: 'Sélection & Destination',
      progress: 'Progression',
      files: 'Fichiers',
      createdBy: 'Créateur',
    },
    selectionSummary: '%{folders} dossier(s) et %{files} fichier(s)',
    failures: '%{count} échec(s)',
    cancel: 'Annuler',
    cancelError: "Impossible d'annuler l'opération : %{error}",
    filterAll: 'Toutes',
    filterActive: 'En cours uniquement',
    newCopy: '+ Nouvelle copie',
    empty: 'Aucune copie enregistrée pour le moment.',
    emptyCta: 'Créer une première copie',
  },
  detail: {
    breadcrumb: 'Historique des copies',
    copy: 'Copie %{id}',
    createdBy: 'Créateur',
    back: '← Retour',
    cancel: 'Annuler la copie',
    retryFailures: 'Réessayer les échecs (%{count})',
    cancelError: "Impossible d'annuler : %{error}",
    retryError: 'Impossible de relancer : %{error}',
    loadError: "Impossible de charger l'opération : %{error}",
    progressSummary: '%{progress}% · %{done} / %{total}',
    copied: 'copiés',
    failed: 'échecs',
    skipped: 'ignorés',
    cancelled: 'annulés',
    currentFile: 'Fichier en cours : %{name}',
    fileDuration: 'copié en %{duration}',
    fileFinishedAt: 'terminé le %{date}',
    destination: 'Destination',
    filesCount: 'Fichiers (%{count})',
    searchPlaceholder: 'Rechercher un fichier…',
    filterAll: 'Tous',
    headers: {
      file: 'Fichier',
      status: 'Statut',
      progress: 'Progression',
      error: 'Erreur',
    },
    emptyFiltered: 'Aucun fichier ne correspond aux filtres.',
    error: 'Erreur',
  },
  statuses: {
    pending: 'En attente',
    running: 'En cours',
    completed: 'Terminée',
    failed: 'Échec',
    cancelled: 'Annulée',
  },
  fileStatuses: {
    pending: 'En attente',
    success: 'Copié',
    failed: 'Échec',
    skipped: 'Ignoré',
    cancelled: 'Annulé',
  },
}
